import { useEffect } from 'react'
import { setCookieConsentVisible } from '../utils/marketingAnalytics'

/**
 * Keep Osano's banner and widget to the public pages: shown while signed out, hidden while
 * signed in. The portal is a single-page app, so without this the widget loaded on the
 * sign-up or login page would follow the user into the product.
 */
export function useCookieConsentVisibility(visible: boolean): void {
  useEffect(() => {
    setCookieConsentVisible(visible)
  }, [visible])
}
